export type FilterFormValues<T> = {
  [key in keyof T]: T[key] | '' | null;
};

export const fromNumberString = (value: string | null) => (value === '' || value === null ? '' : Number(value));
export const fromDateString = (value: string | null) => (value === '' || value === null ? null : new Date(value));

export type FilterItem<T extends number | string = number> = {
  id: T;
  label: string;
};
